import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import isEmpty from 'lodash/isEmpty'
import Button from 'discada/dist/Button'
import debounce from 'lodash/debounce'
import pluralize from 'pluralize'

import Meta from 'components/VRP/Meta'
import ScrollButtons from 'components/widgets/ScrollButtons'
import PricingCard from 'components/VRP/PricingCard'

import { scrollTo } from 'utils'
import { getImages } from 'selectors/inventorySelectors'

import { getEntity } from 'selectors/entitySelectors'
import { getActiveHash } from 'selectors/pageStateSelectors'
import {
  getQuoteId,
  getQuoteDirty,
  getValidModes,
} from 'selectors/quoteSelectors'
import { VRP_SECTIONS } from '.'
import { getWritePermission } from 'selectors/authSelectors'

import { getProfileOk } from 'selectors/appStatusSelectors'

import { DirtyButton } from 'components/widgets/Dirty'

import './Header.scss'

export function Jumper({ currentSection, selectSection, scrollContainer }) {
  return (
    <span className="select jumper is-small">
      <select
        onChange={e => {
          scrollTo(e.target.value, scrollContainer, 50)
          selectSection(e.target.value)
        }}
        value={currentSection}
      >
        {Object.keys(VRP_SECTIONS).map(s => (
          <option key={s} value={s}>
            {VRP_SECTIONS[s]}
          </option>
        ))}
      </select>
    </span>
  )
}

export class Header extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = { currentSection: '', dirty: this.props.dirty }

    this.selectSection = currentSection => this.setState({ currentSection })

    this.checkSection = debounce(() => {
      let scrollContainer = document.querySelector(this.props.scrollContainer),
        scrollContainerTop = scrollContainer ? scrollContainer.scrollTop : 0,
        currentSection = Object.keys(VRP_SECTIONS).find(
          s =>
            document.querySelector(`#${s}`) &&
            scrollContainerTop < document.querySelector(`#${s}`).offsetTop,
        )

      this.selectSection(currentSection)
    }, 500)
  }

  static getDerivedStateFromProps(newProps, oldState) {
    return { ...oldState, dirty: newProps.dirty }
  }

  render() {
    let {
        id,
        className,
        mode,
        vehicle,
        isFixed,
        numberOfImages,
        showPricingCards,
        dirty,
        profileOk,
        okModes,
      } = this.props,
      { openGallery = () => {} } = window

    if (isEmpty(vehicle)) return null

    return (
      <div
        className={c('vrp-header', className, {
          'is-fixed': isFixed,
          'profile-ok': profileOk,
        })}
      >
        <div className="vrp-header-inner">
          <div className="vrp-header-info">
            <span className="vrp-header-info-vehicle">
              <span className="vehicle-name">
                {vehicle.year} <span>{vehicle.make}</span> {vehicle.model}{' '}
                {vehicle.trim}
              </span>
            </span>

            <Meta id={id} showVin />
          </div>
          <div className="vrp-header-controls">
            {dirty ? (
              <DirtyButton {...this.props} size="small" />
            ) : showPricingCards ? (
              <div className="pricing-cards">
                {Object.keys(okModes)
                  .map(k => {
                    if (!okModes[k]) return null

                    let selected = mode === k

                    return (
                      <PricingCard
                        {...this.props}
                        vehicleId={this.props.id}
                        key={k}
                        mode={k}
                        short
                        selected={selected}
                        mini
                        toggle
                      />
                    )
                  })
                  .filter(x => x)}
              </div>
            ) : (
              <ScrollButtons
                container="#vrp-gallery .vrp-gallery-inner"
                size="small"
                invert
              >
                <Button
                  icon="camera"
                  size="small"
                  onClick={() => openGallery(1)}
                >
                  {pluralize('Photos', numberOfImages, true)}
                </Button>
              </ScrollButtons>
            )}
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let mode = getActiveHash(state),
    quoteId = getQuoteId(state, op.id),
    dirty = getQuoteDirty(state, op.id, quoteId),
    okModes = getValidModes(state, op.id, quoteId)

  return {
    ...op,
    mode,
    quoteId,
    dirty,
    okModes,
    vehicle: getEntity(state, op.id),
    numberOfImages: getImages(state, op.id).length,
    isManager: getWritePermission(state, 'deal.fields/profit'),
    profileOk: getProfileOk(state),
  }
}

export default connect(mapStateToProps)(Header)
